import {
  Component,
  OnInit,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-table-edit',
  templateUrl: './table-edit.component.html',
  styleUrls: ['./table-edit.component.scss'],
})
export class TableEditComponent {
  public gridColumnTypes = {
    STT: 'stt',
    Date: 'date',
    DateTime: 'datetime',
    Number: 'number',
    Avatar: 'avatar',
    Text: 'text',
    ComboBox: 'combobox',
    CheckBox: 'checkbox',
    Status: 'status',
    Option: 'option',
    YesNo: 'yesno',
    Mask: 'mask',
    TreeBox: 'treebox'
  };

  @Output() newItemEvent = new EventEmitter<any>();
  @Output() selectedItem = new EventEmitter<any>();
  @Output() initRowEditEvent = new EventEmitter();
  @Output() updateEvent = new EventEmitter();
  @Output() deleteEvent = new EventEmitter();
  @Output() reloadEvent = new EventEmitter();
  @Output() onBlurEvent = new EventEmitter();
  @Output() onDisabledEditor: EventEmitter<any> = new EventEmitter();

  @ViewChild('tbEdit') tableEl: Table;
  @Input() datas: any[];
  @Input() cols: any[];
  @Input() items: any[];
  @Input() permission: any[];
  @Input() tableErrorMsg: any;
  @Input() arrDisabledEditor: any;
  @Input() tableKey: any = null;

  menuItems: any[];
  selectedRow: any = null;
  gridHeight: any = null;
  selectedDropdownItem: any;
  HighlightRow: Number;

  constructor() {
    this.gridHeight = window.innerHeight - 380;
  }

  /**
   * Active row selected
   * @param rowIndex
   */
  clickedRow(rowIndex) {
    this.HighlightRow = rowIndex;
  }

  /**
   * Get row selected data
   * @param row
   */
  onSelectedRow(row: any) {
    this.selectedRow = row;
    this.selectedItem.emit(this.selectedRow);
  }

  /**
   * Sự kiện blur khỏi editor
   * @param row
   */
  onBlur(row: any) {
    this.selectedRow = row;
    this.selectedItem.emit(this.selectedRow);
    this.onBlurEvent.emit();
  }

  /**
   * Khởi tạo row edit
   */
  onRowEditInit(row: any) {
    this.initRowEditEvent.emit();
  }

  /**
   * Save row edit
   */
  onRowEditSave() {
    this.updateEvent.emit();
  }

  /**
   * Hủy sự kiện edit row
   */
  onRowEditCancel() {
    this.reloadEvent.emit();
  }

  /**
   * Delete row edit
   */
  onRowDelete() {
    this.deleteEvent.emit();
  }

  /**
   * Change combobox selection
   * @param event
   * @param row
   * @param field
   * @param valueField
   */
  onChangeCombobox(event: any, row: any, field, valueField) {
    this.selectedRow = row;
    this.selectedRow[field] = event.value;
    this.selectedItem.emit(this.selectedRow);
    this.onBlurEvent.emit();
  }

  /**
   * Change tree combo
   * @param event 
   * @param row 
   * @param mode 
   * @param keyValue 
   * @param field 
   */
  onChangeTreeBox(event: any, row: any, mode: any, keyValue: any, field: any){
    debugger
    this.selectedRow = row;
    if(mode == 'single'){
      this.selectedRow[field] = event.data[keyValue];
    } else {
       this.selectedRow[field] = event
        .map(function (x) {
          return x.data[keyValue];
        })
        .join(',');
    }
    this.selectedItem.emit(this.selectedRow);
    this.onBlurEvent.emit();
  }

  /**
   * Hàm kiểm tra trạng thái disabled của editor
   * @param arrDisabledEditor obj
   * @param field
   * @returns
   */
  disabledEditor(arrDisabledEditor: any, field: any) {
    let res = false;
    if (arrDisabledEditor) {
      res = arrDisabledEditor[field] ? arrDisabledEditor[field] : false;
    }
    return res;
  }

  formatNumber(col, rowData) {
    rowData[col.field] = rowData[col.field]
      .toString()
      .split('')
      .reverse()
      .reduce((prev, next, index) => {
        return (index % 3 ? next : next + '.') + prev;
      });
  }
}
